<template>
	<div class="linkWrap">
		<component
				:is="hasLink ? 'a' : 'div'"
				class="link"
				:href="hasLink ? '/account/user/' + line.user_id : null"
				target="_blank"
				rel="noopener noreferrer"
		>
			{{ line.employee }}
		</component>
	</div>
</template>

<script>
import { PERMISSIONS } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";
import { mapGetters } from "vuex";

export default {
	name: "LinkUser",

	props: {
		item: Object,
		line: Object
	},
	computed: {
		...mapGetters([
			"permissionsDefault",
		]),
	},
	methods: {
		hasLink() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_USERS ];
			return getPermissionsMod({ list, path });
		}
	}
};
</script>

<style scoped lang="scss"></style>
